import { Slot } from 'primitives/slot'
import { tw } from 'utils/classnames'

type BadgeVariants = 'yellow' | 'green' | 'red' | 'purple'

export const Badge = ({
  children,
  className,
  asChild,
  variant = 'yellow',
}: {
  children: React.ReactNode
  className?: string
  asChild?: boolean
  variant?: BadgeVariants
}) => {
  const variants: Record<BadgeVariants, string> = {
    yellow: 'bg-[#f7b500] hover:bg-[#e0a501]',
    green: 'bg-secondary-500 hover:bg-secondary-700',
    red: 'bg-[#c7254e] hover:bg-[#a91f42]',
    purple: 'bg-[#541156] hover:bg-[#400e42]',
  }

  const Comp = asChild ? Slot : 'div'

  return (
    <Comp
      className={tw(
        'text-cf-sf-gray-1000 text-12 text-cf-grey-0 px-2 py-[2px] font-medium font-semibold',
        variants[variant],
        className,
      )}
    >
      {children}
    </Comp>
  )
}
